var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyCardCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 44,
    viewBox: "0 0 320 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.296564L2.00682e-06 44L320 44V0L319.352 2.69647e-08C272.705 26.3385 217.962 41.5032 159.413 41.5032C101.084 41.5032 46.5326 26.4523 0 0.296564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyCardCurve);
export default __webpack_public_path__ + "static/media/survey-card-curve.87b29a0dfedd313af72855994ad9f840.svg";
export { ForwardRef as ReactComponent };